module.exports = __webpack_public_path__ + "static/media/rhg_banner1.eff18fae.jpg";